import {
  CommonLookupItem,
  ProviderWebsiteItem,
} from './common-lookup-item.model';
import { OccupationCategory } from './occupation-category.model';
import { Serializable } from '../../core/models/serializable';
import { Locality } from '@admin/shared/models/locality.model';
import { EducationalInstitutionModel } from '@admin/shared/models/educational-institution-model';
import { SmsTypeModel } from './sms-type-model';
import { EducationalProgramModel } from './educational-program-model';
import { Specialization } from './specializations.model';
import { AdvancedIndustry } from './industry.model';

export class LookupInitData implements Serializable<LookupInitData> {
  public monthListShort: CommonLookupItem<number, string>[];

  public monthListFull: CommonLookupItem<number, string>[];

  public yearList: CommonLookupItem<number, string>[];

  public yearListBirth: CommonLookupItem<number, string>[];

  public occupationCategories: OccupationCategory[];

  public specializations: Specialization[];

  public industries: AdvancedIndustry[];

  public localities: CommonLookupItem<number, string>[];

  public localitiesFull: Locality[];

  public drivingLicenses: CommonLookupItem<number, string>[];

  public jobseekerProfileStates: CommonLookupItem<number, string>[];

  public customerProfileStatuses: CommonLookupItem<number, string>[];

  public educationalPrograms: EducationalProgramModel[];

  public customerIndustries: CommonLookupItem<number, string>[];

  public vehicleTypes: { vehicleTypeId: number; name: string }[];

  public customerNumberOfEmployees: CommonLookupItem<number, string>[];

  public customerTypes: CommonLookupItem<number, string>[];

  public customerFeedTypes: CommonLookupItem<number, string>[];

  public vatStatuses: CommonLookupItem<number, string>[];

  public customerAgentStatuses: CommonLookupItem<number, string>[];

  public genderList: CommonLookupItem<number, string>[];

  public providerWebsiteList: CommonLookupItem<number, string>[];

  public activeProviderWebsiteList: ProviderWebsiteItem[];

  public educationLevelList: CommonLookupItem<number, string>[];

  public educationalInstitutionsList: EducationalInstitutionModel[];

  public languageProficiencyLevelList: CommonLookupItem<number, string>[];

  public worldLanguages: CommonLookupItem<number, string>[];

  public emailTypes: CommonLookupItem<number, string>[];

  public smsTypes: SmsTypeModel[];

  public jobseekerDocumentTypes: {
    jobseekerDocumentTypeId: number;
    name: string;
  }[];

  public messageLanguageCharsets: CommonLookupItem<number, string>[];

  public customerContractTypeList: CommonLookupItem<number, string>[];
  // public languages: Language;
  // public educationLevels: EducationLevel;

  fromObject(obj: any): LookupInitData {
    this.occupationCategories = [];
    this.monthListShort = [];
    this.monthListFull = [];
    this.yearList = [];
    this.yearListBirth = [];
    this.localities = [];
    this.localitiesFull = [];
    this.drivingLicenses = [];
    this.jobseekerProfileStates = [];
    this.customerProfileStatuses = [];
    this.specializations = [];
    this.industries = [];
    this.customerIndustries = [];
    this.customerNumberOfEmployees = [];
    this.customerTypes = [];
    this.customerFeedTypes = [];
    this.vatStatuses = [];
    this.customerAgentStatuses = [];
    this.genderList = [];
    this.providerWebsiteList = [];
    this.educationLevelList = [];
    this.educationalInstitutionsList = [];
    this.languageProficiencyLevelList = [];
    this.worldLanguages = [];
    this.emailTypes = [];
    this.smsTypes = [];
    this.messageLanguageCharsets = [];
    this.customerContractTypeList = [];
    this.activeProviderWebsiteList = [];
    this.educationalPrograms = [];
    this.vehicleTypes = [];
    this.jobseekerDocumentTypes = [];

    if (
      obj.occupationCategories &&
      obj.occupationCategories.length &&
      obj.occupationCategories.length > 0
    ) {
      obj.occupationCategories.forEach((c) => {
        let t = new OccupationCategory();
        t = t.fromObject(c);
        this.occupationCategories.push(t);
      });
    }

    if (
      obj.educationalPrograms &&
      obj.educationalPrograms.length &&
      obj.educationalPrograms.length > 0
    ) {
      obj.educationalPrograms.forEach((c) => {
        this.educationalPrograms.push(c);
      });
    }

    if (
      obj.jobseekerDocumentTypes &&
      obj.jobseekerDocumentTypes.length &&
      obj.jobseekerDocumentTypes.length > 0
    ) {
      obj.jobseekerDocumentTypes.forEach((c) => {
        this.jobseekerDocumentTypes.push(c);
      });
    }

    if (
      obj.vehicleTypes &&
      obj.vehicleTypes.length &&
      obj.vehicleTypes.length > 0
    ) {
      obj.vehicleTypes.forEach((c) => {
        this.vehicleTypes.push(c);
      });
    }

    if (obj.yearList && obj.yearList.length && obj.yearList.length > 0) {
      obj.yearList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.yearList.push(t);
      });
    }

    if (
      obj.yearListBirth &&
      obj.yearListBirth.length &&
      obj.yearListBirth.length > 0
    ) {
      obj.yearListBirth.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.yearListBirth.push(t);
      });
    }

    if (
      obj.monthListShort &&
      obj.monthListShort.length &&
      obj.monthListShort.length > 0
    ) {
      obj.monthListShort.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.monthListShort.push(t);
      });
    }

    if (
      obj.monthListFull &&
      obj.monthListFull.length &&
      obj.monthListFull.length > 0
    ) {
      obj.monthListFull.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.monthListFull.push(t);
      });
    }

    if (
      obj.specializations &&
      obj.specializations.length &&
      obj.specializations.length > 0
    ) {
      obj.specializations.forEach((s) => {
        this.specializations.push(s);
      });
    }

    if (obj.industries && obj.industries.length && obj.industries.length > 0) {
      obj.industries.forEach((ind) => {
        this.industries.push(ind);
      });
    }

    if (obj.localities && obj.localities.length && obj.localities.length > 0) {
      obj.localities.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.localities.push(t);
      });
    }

    if (
      obj.localitiesFull &&
      obj.localitiesFull.length &&
      obj.localitiesFull.length > 0
    ) {
      obj.localitiesFull.forEach((c) => {
        let t = new Locality();
        t = t.fromObject(c);
        this.localitiesFull.push(t);
      });
    }

    if (
      obj.drivingLicenses &&
      obj.drivingLicenses.length &&
      obj.drivingLicenses.length > 0
    ) {
      obj.drivingLicenses.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.drivingLicenses.push(t);
      });
    }

    if (
      obj.jobseekerProfileStates &&
      obj.jobseekerProfileStates.length &&
      obj.jobseekerProfileStates.length > 0
    ) {
      obj.jobseekerProfileStates.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.jobseekerProfileStates.push(t);
      });
    }

    if (
      obj.customerProfileStatuses &&
      obj.customerProfileStatuses.length &&
      obj.customerProfileStatuses.length > 0
    ) {
      obj.customerProfileStatuses.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerProfileStatuses.push(t);
      });
    }

    if (
      obj.customerIndustries &&
      obj.customerIndustries.length &&
      obj.customerIndustries.length > 0
    ) {
      obj.customerIndustries.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerIndustries.push(t);
      });
    }

    if (
      obj.customerNumberOfEmployees &&
      obj.customerNumberOfEmployees.length &&
      obj.customerNumberOfEmployees.length > 0
    ) {
      obj.customerNumberOfEmployees.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerNumberOfEmployees.push(t);
      });
    }

    if (
      obj.customerTypes &&
      obj.customerTypes.length &&
      obj.customerTypes.length > 0
    ) {
      obj.customerTypes.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerTypes.push(t);
      });
    }

    if (
      obj.customerFeedTypes &&
      obj.customerFeedTypes.length &&
      obj.customerFeedTypes.length > 0
    ) {
      obj.customerFeedTypes.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerFeedTypes.push(t);
      });
    }

    if (
      obj.vatStatuses &&
      obj.vatStatuses.length &&
      obj.vatStatuses.length > 0
    ) {
      obj.vatStatuses.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.vatStatuses.push(t);
      });
    }

    if (
      obj.customerAgentStatuses &&
      obj.customerAgentStatuses.length &&
      obj.customerAgentStatuses.length > 0
    ) {
      obj.customerAgentStatuses.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerAgentStatuses.push(t);
      });
    }

    if (obj.genderList && obj.genderList.length && obj.genderList.length > 0) {
      obj.genderList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.genderList.push(t);
      });
    }

    if (
      obj.providerWebsiteList &&
      obj.providerWebsiteList.length &&
      obj.providerWebsiteList.length > 0
    ) {
      obj.providerWebsiteList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.providerWebsiteList.push(t);
      });
    }

    if (
      obj.activeProviderWebsiteList &&
      obj.activeProviderWebsiteList.length &&
      obj.activeProviderWebsiteList.length > 0
    ) {
      obj.activeProviderWebsiteList.forEach((c) => {
        this.activeProviderWebsiteList.push(c);
      });
    }

    if (
      obj.educationLevelList &&
      obj.educationLevelList.length &&
      obj.educationLevelList.length > 0
    ) {
      obj.educationLevelList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.educationLevelList.push(t);
      });
    }

    if (
      obj.educationalInstitutionsList &&
      obj.educationalInstitutionsList.length &&
      obj.educationalInstitutionsList.length > 0
    ) {
      obj.educationalInstitutionsList.forEach((c) => {
        let t = new EducationalInstitutionModel();
        t = t.fromObject(c);
        this.educationalInstitutionsList.push(t);
      });
    }

    if (
      obj.languageProficiencyLevelList &&
      obj.languageProficiencyLevelList.length &&
      obj.languageProficiencyLevelList.length > 0
    ) {
      obj.languageProficiencyLevelList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.languageProficiencyLevelList.push(t);
      });
    }

    if (obj.emailTypes && obj.emailTypes.length && obj.emailTypes.length > 0) {
      obj.emailTypes.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.emailTypes.push(t);
      });
    }

    if (obj.smsTypes && obj.smsTypes.length && obj.smsTypes.length > 0) {
      obj.smsTypes.forEach((c) => {
        let t = new SmsTypeModel();
        t = t.fromObject(c);
        this.smsTypes.push(t);
      });
    }

    if (
      obj.messageLanguageCharsets &&
      obj.messageLanguageCharsets.length &&
      obj.messageLanguageCharsets.length > 0
    ) {
      obj.messageLanguageCharsets.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        t.value = +t.value;
        this.messageLanguageCharsets.push(t);
      });
    }

    if (
      obj.worldLanguages &&
      obj.worldLanguages.length &&
      obj.worldLanguages.length > 0
    ) {
      obj.worldLanguages.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.worldLanguages.push(t);
      });
    }

    if (
      obj.customerContractTypeList &&
      obj.customerContractTypeList.length &&
      obj.customerContractTypeList.length > 0
    ) {
      obj.customerContractTypeList.forEach((c) => {
        let t = new CommonLookupItem<number, string>();
        t = t.fromObject(c);
        this.customerContractTypeList.push(t);
      });
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
